var _path, _path2, _path3, _path4, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoFavourites(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 182 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.088 137.608C4.63868 123.68 -0.163849 107.296 0.00427111 89.7799C0.48345 39.813 40.9211 -0.105633 90.9212 0.000209991C140.938 0.105683 181.451 40.6593 181.451 90.6692C181.451 106.766 177.254 121.883 169.894 134.987C167.798 138.717 163.822 141 159.541 141H19.1329C16.6641 141 14.3678 139.718 13.088 137.608Z",
    fill: "#20AEF3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.438 42.3636H133.262V25.7812C133.262 19.1601 138.63 13.7927 145.251 13.7927C151.872 13.7927 157.24 19.1601 157.24 25.7812V39.5625C157.24 41.1096 155.986 42.3636 154.438 42.3636Z",
    fill: "#FFF0DD",
    stroke: "#081275",
    strokeWidth: 3.58537
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.469 138.832H49.7229C53.1639 135.976 55.3552 131.666 55.3552 126.844V25.7812C55.3552 19.1601 60.7226 13.7927 67.3438 13.7927H140.09C136.649 16.6494 134.457 20.9594 134.457 25.7812V126.844C134.457 133.465 129.09 138.832 122.469 138.832Z",
    fill: "#FFF0DD",
    stroke: "#081275",
    strokeWidth: 3.58537
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M106.895 126.844C106.895 131.666 109.086 135.976 112.527 138.832H39.7812C33.1601 138.832 27.7927 133.465 27.7927 126.844V122.25C27.7927 120.703 29.0466 119.449 30.5938 119.449H104.094C105.641 119.449 106.895 120.703 106.895 122.25V126.844Z",
    fill: "#FFF0DD",
    stroke: "#081275",
    strokeWidth: 3.58537
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 98.0488,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 98.0488,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 98.0488,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 98.0488,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 98.0488,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 78.9268,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 78.9268,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 78.9268,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 78.9268,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 78.9268,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 59.8049,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 59.8049,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 59.8049,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 59.8049,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 59.8049,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 39.4878,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 39.4878,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 39.4878,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 39.4878,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 65.4395,
    y: 39.4878,
    width: 62.1463,
    height: 4.78049,
    rx: 1.19512,
    fill: "#20AEF3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1562 103.875C75.9157 103.875 90.3125 89.4782 90.3125 71.7188C90.3125 53.9593 75.9157 39.5625 58.1562 39.5625C40.3968 39.5625 26 53.9593 26 71.7188C26 89.4782 40.3968 103.875 58.1562 103.875Z",
    fill: "#FF6E91"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5216 57.4146C63.5689 57.4146 60.1767 59.8111 58.7168 63.2297C57.2568 59.8111 53.8646 57.4146 49.912 57.4146C44.6266 57.4146 40.3418 61.6991 40.3418 66.9848C40.3418 83.063 58.7168 90.719 58.7168 90.719C58.7168 90.719 77.0918 83.063 77.0918 66.9848C77.0918 61.6991 72.807 57.4146 67.5216 57.4146Z",
    fill: "#5AE0B9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFavourites);
export default __webpack_public_path__ + "static/media/NoFavourites.345c4cf8450aaa46aeb46c53dd65b054.svg";
export { ForwardRef as ReactComponent };